<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('AirExport.CompleteOperationRequirements')"
    width="300px"
  >
    <el-form label-width="80px">
      <el-form-item :label="$t('CargoMsg.Cargo_CompletionTime')">
        <el-date-picker ref="finishedDate" v-model="form.finishedDate" value-format="yyyy-MM-dd" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
        <el-input v-model="form.remarks" type="textarea" :row="5" style="width: 200px" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="okClickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button type="default" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'FinishedWindow',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      form: {
        finishedDate: '',
        remarks: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.form.finishedDate = ''
        this.form.remarks = ''
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    okClickHandler() {
      if (!this.form.finishedDate) {
        this.$message.warning(this.$t('AirExport.PleaseSelectTheCompletionTime'))
        this.$refs.finishedDate.focus()
        return
      }
      this.$emit('saveCallBack', this.form.finishedDate, this.form.remarks)
      this.closeHandler()
    },
    closeHandler() {
      this.innerVisible = false
    }
  }
}
</script>

<style scoped>

</style>
